import { render, staticRenderFns } from "./HowItWorksItemRight.vue?vue&type=template&id=046b4aaa&"
import script from "./HowItWorksItemRight.vue?vue&type=script&lang=js&"
export * from "./HowItWorksItemRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports